import CarouselComponent from "../components/CarrouselComponent";

export default function HomePage() {
  return (
    <div className="flex flex-col gap-6">
      <div className="font-gray-500 font-semibold">
        <p className="mb-2">Welkom op mijn website!</p>
        <p className="mb-2">Mijn naam is Ans Christiaens. Kijk rustig rond op deze website om mijn werk te bekijken.</p>
      </div>
      <div className="p-4 font-gray-500 font-semibold bg-slate-100 rounded flex flex-col sm:flex-row gap-6">
      <div className="max-w-[100px] flex flex-col justify-center w-[100px]"><img src="rvdk.png" alt="Route van de Kunst" className="" /></div>
        <div className="flex-1 mt-4">
          <p className="mb-2">Tijdens de Pinksterdagen, 24 en 25 mei, vindt de Route van de Kunst 2026 plaats in de dorpen Haarsteeg, Vlijmen, Nieuwkuijk en Drunen. 
            Mijn werk is te zien op een gastlocatie, Het Stuurhuis, Kerkstraat 19B, Nieuwkuijk.</p>
          <p className="mb-2">De route is 2 volle dagen te bezoeken van 11.00 tot 17.00 uur.</p>        
          <p><a href="https://routevandekunst.nl/" target="_blank" rel="noreferrer" className="text-blue-600">https://routevandekunst.nl/</a></p>
        </div>
      </div>
      <div className="flex justify-center">
        <CarouselComponent />
      </div>      
    </div>
  )
}
